import { useEffect, useState } from 'react';

import { useDebouncedCallback } from './useRateLimitedCallback';

export function useWindowResize(callback: () => void, debounceDelay = 150) {
	const [handleResize] = useDebouncedCallback(callback, debounceDelay);

	useEffect(() => {
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [handleResize]);
}

export interface WindowSize {
	height: number;
	width: number;
}

const getWindowSize = (): WindowSize => ({
	height: globalThis.innerHeight || 0,
	width: globalThis.innerWidth || 0,
});

export function useWindowSize(debounceDelay = 150): WindowSize {
	const [size, setSize] = useState<WindowSize>(getWindowSize());

	useWindowResize(() => {
		setSize(getWindowSize());
	}, debounceDelay);

	return size;
}
